import { gql } from "@apollo/client";

export default gql`
  mutation testAiWithConversation($data: TestAiWithConversationInput!){
    testAiWithConversation(data: $data){
        success
        data{
            conversationId
            personId
            aiPersonMemoryId
            aiProfileId
            aiMessageId
            aiRole
            media{
                path
                type
            }
            commerceProductCards{
                productId
                title
                thumbnailUrl
                optionsSummary
                productUrl
                price{
                    amount
                    currency
                }
            }
            content
            summary
            tagIds
            noNeedInfoContent
            detailedMessage
            actions{
                isPositive
                isNegative
                isHumanSupport
            }
            aiAction
            responseExplanation{
                code
                stage
                detail
            }
            sideEffects{
                kind
                targetId
                targetName
                dryRun
            }
            skillActions{
                command
                success
                dryRun
                error
            }
            privateReply{
                content
                aiAction
                isOnlyReply
            }
            commerceApproval{
                buttonId
                title
                content
            }
            commerceLinks{
                url
                title
            }
            dryRunSkipped{
                kind
                name
            }
        }
        code
        message
    }
}
`
